<template>
  <div
    class="pointer-events-none fixed bottom-0 left-0 right-0 z-40 p-4 opacity-0 transition-opacity"
    :class="{ '!opacity-100': !isHidden }"
  >
    <div
      class="rounded-lg bg-black p-3 text-sm text-white shadow-lg sm:max-w-xs"
      :class="{ 'bg-red-500': flash.kind === 'alert' }"
    >
      {{ flash.message }}
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'

  const props = defineProps<{ flash: NMFlash }>()
  const isHidden = ref(false)

  const hideTimeout = ref(0)

  const show = () => {
    window.clearTimeout(hideTimeout.value)

    isHidden.value = false
    hideTimeout.value = window.setTimeout(() => {
      isHidden.value = true
    }, 2500)
  }

  setTimeout(show, 100)

  watch(() => props.flash, show)
</script>
